.card {
  position: relative;
  border-radius: var(--radius-md);
  overflow: hidden;
  aspect-ratio: 1 / 1;
  box-shadow: var(--shadow-card);
}

.image {
  position: absolute;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.overlay {
  position: absolute;
  inset: 0;
  background: linear-gradient(180deg, rgba(0, 0, 0, 0.15), rgba(0, 0, 0, 0.7));
}

.content {
  position: relative;
  z-index: 1;
  color: #fff;
  display: flex;
  flex-direction: column;
  gap: var(--space-3);
  justify-content: flex-end;
  padding: var(--space-5);
  text-transform: uppercase;
  letter-spacing: 0.18em;
}

.content h3 {
  margin: 0;
  font-size: 1rem;
}

.link {
  display: inline-flex;
}
